export default __webpack_public_path__ + "static/media/kangoo-gallery-7.bced152c.jpg";